export const queryKeys = Object.freeze({
  player: {
    base: ["player"] as const,
    random: (uuid: string) => [...queryKeys.player.base, uuid],
  },
});

export const mutationKeys = Object.freeze({});
